import React, {Fragment} from 'react'

const BlockStyleFive = () => {
    return (
        <Fragment>
            <div className="block-style-five ps-xxl-5 ms-xxl-4">
                <h6 className="sub-title mb-20" data-aos="fade-up">You Tube Channel</h6>
                <h3 className="sect-title mb-20">Sumbupulsa</h3>
                <p className="pe-xxl-5 mb-55">Berikut adalah video cuplikasi sumbupulsa tonton jangan sampai kelewatan.
                </p>
            </div>
        </Fragment>
    )
}

export default BlockStyleFive